import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
// window.jQuery = $;
// window.$ = $;

require('foundation-sites');

// npm install object-fit-images
import objectFitImages from 'object-fit-images';

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

$(document).foundation();

var stylesheet_uri = $('body').data('stylesheet');

// function to make mailto from span
  $.fn.buildMailTo = function() {
    var $t = this; // freakin scope
    var pre     = $t.data('pre'),
        post    = $t.data('post'),
        subject = $t.data('subject'),
        classes = $t.attr('class'),
        text    = $t.text();

    var href = 'mailto:' + pre + '@' + post;
    if ( subject )
      href = href + '?subject=' + subject;

    $t.replaceWith( '<a href="' + href + '" class="' + classes + '">' + text + '</a>' );
    return this;
  }

// PLACEHOLDER TEXT SEARCHFIELD
var apolloPlaceholder = {

  init: function() {
    apolloPlaceholder.timeout_var = null;
    var $target = $('.placehold-this');
    var text    = $target.parents('.form-wrap').find('.placephrase').text().split(",");

    apolloPlaceholder.writer( $target, text );
    apolloPlaceholder.bindEvent( $target );
  },

  writer: function( $el, text, i = 0, li = 0, delay=80 ) {
    if (!i)
      $el.attr('placeholder','');

    var phrase = text[li];

    if (typeof phrase === 'undefined' ) {

      setTimeout(function() {
        apolloPlaceholder.writer( $el, text );
      }, (delay));

    } else {
      phrase = phrase.trim();
      if (i < phrase.length) {
        let is = $el.attr('placeholder');
        $el.attr('placeholder', is + phrase.charAt(i));
        i++;
        setTimeout(function() {
          apolloPlaceholder.writer( $el, text, i, li );
        },delay);
      } else {
        li++;
        setTimeout(function() {
          apolloPlaceholder.writer( $el, text, 0, li );
        }, (delay * 50));
      }
    }
  },

  bindEvent: function( $el ) {
    $el.focus(function() {
      $(this).attr('placeholder','');
    });
  }

}

var apolloMagellan = {

  init: function () {
    console.log('Module Executed: Magellan Navigation');

    apolloMagellan.bindListeners();
  },

  bindListeners: function () {
    var $magellan = $('#magellan'),
        $counter  = $('.magellan-counter', $magellan),
        $menu     = $('.magellan-menu', $magellan);

    $magellan.on('mouseenter',function() {
      $counter.hide();
      $menu.show();
    }).on('mouseleave',function() {
      $menu.hide();
      $counter.show();
    });

    // update chapter counter
    $magellan.on('update.zf.magellan',function() {
      var i = $('.magellan-menu a.is-active').parent().index() + 1;
      if ( i === -1 || i === 0 ) {
        i = 1;
      }
      $('.magellan-counter span:first').text(i);
    });
  }
}

var apolloGdprYoutube = {

  init: function () {
    console.log('Module Executed: GDPR Youtube');

    apolloGdprYoutube.bindYTActions();
  },

  bindYTActions: function() {
    $('.yt-disc-play').on('click',function() {
      var $next = $(this).next();
      $next.css({'padding-bottom':'90px'});
      setTimeout(function() { $next.css({'padding-bottom':''}); }, 2000);
    });

    $('button.load-video').on('click',function() {
      apolloGdprYoutube.loadVideo( $(this).parents('.flex-video') );
    });
  },

  loadVideo: function( $container ) {
    var vid = $container.attr('data-video');
    $container.empty().html('<iframe src="'+ vid +'&autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
  },
}

var apolloSearch = {
  init: function () {
    console.log('Module Executed: Ajax Search');

    $('.set-type').on('click',function(e) {
      e.preventDefault();
      var _this = $(this);
      var type =  _this.attr('data-type')

      if ( !_this.is('.is-selected') ) {
        $('.set-type').removeClass('is-selected');
        $('#s_type').find('option').attr('selected','');

        _this.addClass('is-selected');
        $('#s_type').find('option[value='+ type +']').attr('selected','selected');
      } else {
        _this.removeClass('is-selected');
        $('#s_type').find('option').attr('selected','');
      }

    });

    // $('#searchsubmit', '#searchform').on('click', function(e) {
    //   //e.preventDefault();
    //   apolloSearch.find_posts(0);
    // });
  },

  set_selected: function() {

  },

  // SETUP SEARCH DATA
  prepare_filter: function() {
    var filter = [];
    // Get the values
    var s_keywords = $('#s_keyword', '#searchform').val();
    // var s_year     = $('#s_year', '#searchform').val();
    // var s_month    = $('#s_month', '#searchform').val();
    var s_type     = $('#s_type', '#searchform').val();
    // var s_area     = $('#s_area', '#searchform').val();
    // var s_types    = $('#s_types', '#searchform').val();

    // If keywords exist, push to filter
    if (s_keywords != '') {
        filter.push({ s_keywords: s_keywords });
    }
    // If date from exists, push to filter
    // if (s_year != '') {
    //     filter.push({ s_year: s_year });
    // }
    // if (s_month != '') {
    //     filter.push({ s_month: s_month });
    // }
    if (s_type != '') {
        filter.push({ s_type: s_type });
    }
    // if (s_area != '') {
    //     filter.push({ s_area: s_area });
    // }
    // if (s_types != '') {
    //     filter.push({ s_types: s_types });
    // }
    // Output the results in the console
    console.log(JSON.stringify(filter));
    return filter;
  },

  find_posts: function( pageNumber ) {
    // ui feedback
    $('#appendMe').addClass('ajax-loading');

    var filter = apolloSearch.prepare_filter();
    pageNumber++;
    // Send to my_search_results
    $.ajax({
      url:    '/wp-admin/admin-ajax.php',
      type:   'POST',
      data:   {
        action: 'ajax_search',
        filter: filter,
        page: pageNumber,
      },
      success: function( html ) {
        if ( pageNumber > 1 ) {
          $('#appendMe').append( html ).removeClass('ajax-loading');
        } else {
          $('#appendMe').html( html ).removeClass('ajax-loading');
        }
        $('#appendMe').foundation();

      //  bind_accordion_trigger( $('#appendme') );
      //  bind_ajaxloader( $('#appendme') );
      }
    });
  }
}


$('#mainMenu a').each(function(){
  if( $(this).is('.is-active') && $(this).parent().parent().is('.submenu') ) {
    console.log('true');
    $('#mainMenu').foundation('down', $(this).parent().parent());
  }
});

$('#offCanvasMenu').on('opened.zf.offCanvas', function() {
  $('body').addClass('is-menu-open');
}).on('close.zf.offCanvas', function() {
  $('body').removeClass('is-menu-open');
});

$('#offCanvasMeta').on('opened.zf.offCanvas', function() {
  $('body').addClass('is-metabar-open');

  if ( Foundation.MediaQuery.current == 'xlarge' ) {
    if ( $('body').is('.is-menu-open') ) {
      $('#offCanvasMenu').foundation('close');
      $('body').addClass('was-menu-open');
    }
  }
}).on('close.zf.offCanvas', function() {
  $('body').removeClass('is-metabar-open');

  if ( $('body').is('.was-menu-open') ) {
    $('#offCanvasMenu').foundation('open');
    $('body').removeClass('was-menu-open');
  }
});

$(window).on('load resize', function() {
  if ( Foundation.MediaQuery.atLeast('xlarge') )
    $('#offCanvasMenu').foundation('open');
  else
    $('#offCanvasMenu').foundation('close');
});


// SUPER USEFULL
// Restart svg background animation by reloading file and avaoid caching (random string insertion)
$('.rstrtme').on('mouseenter',function() {
  var bg = $(this).css('background-image');
  var rand = Math.random();
  var randstr = " random='rstart" + rand + "rend' ";
  var svgpos = bg.indexOf('%3Csvg') + 6;

  if (/random/i.test(bg)) {
    var data = bg.replace(/rstart.+rend/,"rstart" + rand + "rend");
  } else {
    var data = [bg.slice(0, svgpos), randstr, bg.slice(svgpos)].join('');
  }
  $(this).css({'background-image':data});
}).on('click',function() {
  $(this).css({'background-image':''});
});

$(document).ready(function() {

  // lazyloading
  //$('img').unveilFreinds();

  // IE polyfill for image object fit
  objectFitImages();

  // MAILS
  $('.liambtn').each(function() {
    $(this).buildMailTo();
  });

  //
  apolloMagellan.init();
  apolloGdprYoutube.init();
  apolloPlaceholder.init();
  apolloSearch.init();
  //apolloScroll.init();
  //apolloDomready.init();

});
